import React, { Component } from 'react'
import './EventInvitee.less'
import { t } from '@lingui/macro'

import UserDetail from '../../../../components/common/user/user-detail/UserDetail'
import { UserModel } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { ListItem } from 'front-end/src/components'

class EventInvitee extends Component<{
  user: UserModel
  attending: boolean | null | undefined
  isFacilitator: boolean | null | undefined
}> {
  render() {
    const { user } = this.props
    const meta: string[] = []
    if (user.position && user.position.length) {
      meta.push(user.position)
    }
    if (this.props.isFacilitator) {
      meta.push(t`Facilitator`)
    }
    return (
      <ListItem mb="8px">
        <UserDetail
          display_name={user.display_name}
          imageUrl={user.image_url}
          meta={meta.join(', ')}
        />
      </ListItem>
    )
  }
}

export default EventInvitee
